import { render, staticRenderFns } from "./PageShoplist.vue?vue&type=template&id=94847e50&"
import script from "./PageShoplist.vue?vue&type=script&lang=js&"
export * from "./PageShoplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94847e50')) {
      api.createRecord('94847e50', component.options)
    } else {
      api.reload('94847e50', component.options)
    }
    module.hot.accept("./PageShoplist.vue?vue&type=template&id=94847e50&", function () {
      api.rerender('94847e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/PageShoplist.vue"
export default component.exports